module.exports = __webpack_public_path__ + "static/header-31dd14aff7e8d39c58ee35c4d5ee7e9a.png";